import { BaseListRepository } from 'core/classes';
import { City } from '../interfaces';
import { cityResource } from '../resources/CityResource';
import { CityLoadParams } from '../types';

class CityRepository extends BaseListRepository<City, CityLoadParams> {}

export const cityRepository = new CityRepository(cityResource);
